import axios from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import {
  generateXB3TraceID,
  getChannelID,
  getHost,
  getTmxId,
  isSsr,
} from '../utils/general';
import { getAuthorizationToken } from '../utils/user';

const baseurl = getHost();
const channelId = getChannelID();

const TMXProfileID = isSsr ? '' : getTmxId();
const Client = 'ocm_pd_experience_customer-account-orders-purchases';

const baseConfig = {
  baseURL: baseurl,
  headers: {
    channelId,
    TMXProfileID,
    Authorization: getAuthorizationToken(),
    'X-B3-TraceId': generateXB3TraceID(),
    Client,
  },
  timeout: REQUEST_TIMEOUT,
};

export const b2cConfig = {
  baseURL: baseurl,
  headers: {
    channelId,
    TMXProfileID,
    Authorization: getAuthorizationToken(),
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Client,
  },
  timeout: REQUEST_TIMEOUT,
};

export const b2bConfig = {
  baseURL: baseurl,
  headers: {
    channelId,
    TMXProfileID,
    'X-B3-TraceId': generateXB3TraceID(),
    Client,
  },
  timeout: REQUEST_TIMEOUT,
};

export const rmsConfig = {
  baseUrl: baseurl,
  headers: {
    channelId,
    Client,
    Cookie: '', // THD_CUSTOMER cookie for b2b, THD_USER_SESSION for b2c. Only one should be present
    // TraceId: generateXB3TraceID(),
  },
  timeout: REQUEST_TIMEOUT,
};

export const cmsConfig = {
  baseUrl: baseurl,
  headers: {
    channelId,
    Client,
    Cookie: '', // THD_CUSTOMER cookie for b2b, THD_USER_SESSION for b2c. Only one should be present
    // TraceId: generateXB3TraceID(),
  },
  timeout: REQUEST_TIMEOUT,
};

export const ommConfig = {
  baseUrl: baseurl,
  headers: {
    channelId,
    Client,
    Cookie: '', // THD_CUSTOMER cookie for b2b, THD_USER_SESSION for b2c. Only one should be present
    // TraceId: generateXB3TraceID(),
  },
  timeout: REQUEST_TIMEOUT,
};

/**
 * Speical Client Function for buildertrend link and unlink
 * @param code - buildertrend code from given from buildertrend when hitting
 * our page. Must be passed in header under 'BT-Code'
 */
const getBuildertrendAxiosClient = (code: string) => {
  const integrationClientBase = {
    baseURL: baseurl,
    headers: {
      channelId,
      TMXProfileID,
      'X-B3-TraceId': (
        Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16)
      ).substring(0, 15),
      'BT-Code': code,
    },
  };

  return integrationClientBase;
};

const apiBase = axios.create(baseConfig);

const apiB2C = axios.create(b2cConfig);

const apiB2B = axios.create(b2bConfig);

const apiRMS = axios.create(rmsConfig);

const apiCMS = axios.create(cmsConfig);

const apiOMM = axios.create(ommConfig);

const apiBaseWithBlob = axios.create({ ...baseConfig, responseType: 'blob' });

const apiB2BWithBlob = axios.create({ ...b2bConfig, responseType: 'blob' });

/* export const integrationClientChannelId = {
  client: axios.create({ ...integrationClientBase, responseType: 'json' }),
}; */

export {
  apiBase,
  apiB2C,
  apiB2B,
  apiRMS,
  apiCMS,
  apiOMM,
  apiBaseWithBlob,
  apiB2BWithBlob,
  getBuildertrendAxiosClient,
};
